import { Breadcrumb } from '../models/breadcrumb.interface';

export const BreadcrumbType = {
  Home: { key: 'Home', label: 'Accueil', link: '/' },
  SearchBRC: { key: 'SearchBRC', label: 'Recherche CRB', link: '/brc/list' },
  SearchAS: { key: 'SearchAS', label: 'Recherche SA', link: '/as/list' },
  SearchUO: { key: 'SearchUO', label: 'Recherche UO', link: '/uo/list' },
} satisfies Record<string, Breadcrumb>;

export type BreadcrumbType = keyof typeof BreadcrumbType;
